// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"54":"215ac9f0c82d355d","888":"91fe1c19e5b67efb","968":"54210ead9d99873d"}[chunkId] + ".css";
};